import { Toaster as SonnerToaster, toast } from "sonner"
import * as React from "react"
import { ThemeContext } from "@/shared/lib/theme"

export function Toaster() {
  const ctx = React.useContext(ThemeContext)
  const theme = ctx?.theme === "dark" ? "dark" : "light"

  return (
    <SonnerToaster
      theme={theme}
      position="top-right"
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast: "font-sans text-body2",
        },
      }}
    />
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export { toast }
